import { gql } from 'graphql-request'

export const CREATE_WRITER = gql`
  mutation CreateWriter($createWriterInput: CreateWriterInput!) {
    createWriter(createWriterInput: $createWriterInput) {
      id
      bankAccount {
        bankName
        bankBranch
        bankProvince
        accountNumber
        accountName
        accountType
        bankCoverImgPath
        bankCode
        bankBranchCode
      }
      writer {
        id
        affiliation
        writersConsents {
          consent {
            id
            name
            content
          }
          createdAt
        }
      }
      type
      affiliation
      fullName
      idNumber
      email
      phoneNumber
      residence
      country
      address
      postcode
      province
      district
      subDistrict
      idCardImgPath
      isSameMainAddress
      sendResidence
      sendCountry
      sendAddress
      sendPostcode
      sendProvince
      sendDistrict
      sendSubDistrict
      certificationTax
      companyName
      taxId
      companyCertificateImgPath
      vatRegistrationCertificateImgPath
      coordinatorFullName
      coordinatorEmail
      coordinatorPhoneNumber
      accountingFullName
      accountingEmail
      accountingPhoneNumber
      certificateCountry
      certificateAddress
      certificatePostcode
      certificateProvince
      certificateDistrict
      certificateSubDistrict
      writersConsents {
        consent {
          id
          name
          content
        }
        createdAt
      }
      status
      rejectedReason
    }
  }
`
